module.exports = __webpack_public_path__ + "components/check-list/static/checkmark-circle-f02cbc33beca81f535700ac3e1451a68.svg";